import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'
import forEach from 'lodash/forEach';
import * as Spinners from '@Services/Spinners';

import SimpleSpinner from './SimpleSpinner';

const SPINNER_SIZE = {
  width: 2.375,
  height: 2.375,
};

export default class RxSpinnerComponent extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {enabled: props.autoStart};

    this.toggleState = this.toggleState.bind(this);
  }

  toggleState(enabled) {
    this.setState({
      enabled,
    });
  }

  scaleSize() {
    const scale = this.props.spinnerScale;
    const styles = {};

    forEach(SPINNER_SIZE, (value, key) => (styles[key] = `${value * scale}rem`));
    return styles;
  }

  componentDidMount() {
    Spinners.register(this.props.spinnerId, this.toggleState);
  }

  componentWillUnmount() {
    Spinners.unregister(this.props.spinnerId);
  }

  render() {
    const { enabled } = this.state;
    const { position } = this.props;

    if (!enabled) {
      return null;
    }

    const classNames = classnames(`rx-loader--container rx-loader--container__${position}`, this.props.spinnerClass);

    return (
      <SimpleSpinner
        className={classNames}
        spinnerAnimationStyle={this.scaleSize()}
      />
    );
  }
}

RxSpinnerComponent.defaultProps = {
  autoStart: false,
  spinnerClass: 'search-sync-icon',
  spinnerScale: 1.5,
  position: 'absolute',
};

RxSpinnerComponent.propTypes = {
  spinnerId: PropTypes.string.isRequired,
  autoStart: PropTypes.bool,
  spinnerClass: PropTypes.string,
  spinnerScale: PropTypes.number,
  position: PropTypes.string,
};
